import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { MessageService } from '@mprep/shared/core/services'
import { Message, MessageOptions, IMessageAction } from '@mprep/shared/core/models'

import { ExpirationMessage } from '@mprep/shared/data/models'
import { ExpirationMessageService } from '@mprep/shared/lib/data/services'

@Injectable()
export class UIExpirationMessageService {
  constructor(
    private _expirationMessageService: ExpirationMessageService,
    private _messageService: MessageService
  ) {}

  public broadcastExpiringProducts(): Observable<number> {
    return this._expirationMessageService.getExpirationMessage().map((expirationMessage) => {
      if (expirationMessage.message) {
        const message = this._createMessage(expirationMessage)
        this._messageService.send(message)
      }
      return 1
    })
  }

  private _createMessage(expirationMessage: ExpirationMessage): Message {
    const messageOptions = this._createMessageOptions(expirationMessage)
    const messageText = expirationMessage.message
    return this._messageService.createWarningMessage(messageText, messageOptions)
  }

  private _createMessageOptions(expirationMessage: ExpirationMessage): MessageOptions {
    const messageOptions = {} as MessageOptions
    messageOptions.topic = 'expiration'
    messageOptions.subject = expirationMessage.title
    messageOptions.actions = this._actions(expirationMessage)
    return messageOptions
  }

  private _actions(expirationMessage: ExpirationMessage): IMessageAction[] {
    const actions = [
      ({ label: 'ignore', type: 'hideMessage', value: '' } as IMessageAction),
    ]

    if (expirationMessage.purchaseUrl !== '') {
      actions.push({
        label: 'add to cart',
        type: 'extendAccess',
        value: `${expirationMessage.purchaseUrl}`
      } as IMessageAction
    )}

    return actions
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/ui-expiration-message/ui-expiration-message.service.ts